import { Button, Group, Select, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconLayersSelected } from "@tabler/icons-react";
import { deleteFromUnsub } from "../../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import { useProfileStore } from "../../../../../stores/UserStore";

const UndoubleUnsub = ({ id, handleClose, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [org, setOrg] = useState(null);

  const [loading, setLoading] = useState(false);

  const main = () => {
    setLoading(true);
    deleteFromUnsub({
      id,
      organization_id: parseInt(org),
    })
      .then((res) => {
        onFinish?.();
        notifications.show({
          message: lang.contact_lists.undouble.success,
          color: "tertiary.8",
        });
        handleClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack w={300}>
      <Stack gap={16}>
        <Text>{lang.contact_lists.undouble.text_unsub}</Text>
        <Select
          label={lang.contact_lists.undouble.org_label}
          placeholder={lang.contact_lists.undouble.org_placeholder}
          value={org}
          onChange={setOrg}
          data={profile?.organizations.map((x) => ({
            label: x.name,
            value: x.id.toString(),
          }))}
          comboboxProps={{
            zIndex: 1700,
            withinPortal: false,
          }}
        />
      </Stack>
      <Group justify="end">
        <Button
          leftSection={<IconLayersSelected size={16} />}
          onClick={main}
          loading={loading}
          color="red"
        >
          {lang.contact_lists.undouble.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default UndoubleUnsub;
